/**
 * 處理身份驗證相關的協調邏輯
 * 避免 store 之間的循環依賴
 */
import { ref, readonly } from 'vue'
import { useAuthStore } from '~/stores/storeAuth'
import { useCartState } from '~/stores/storeCart'
import { useUserInfoStore } from '~/stores/storeUserInfo' 

// 全域登出狀態標記，避免重複執行（真正的全域狀態）
const isProcessingSignOut = ref(false)

export const useAuthHandler = () => {
  const authStore = useAuthStore()
  const cartStore = useCartState()
  const userStore = useUserInfoStore()

  /**
   * 處理未授權錯誤 (401)
   * 協調所有相關 store 的清理工作
   */
  const handleUnauthorized = async () => {
    // 防止重複執行登出流程
    console.log("isProcessingSignOut : ", isProcessingSignOut.value);
    if (isProcessingSignOut.value) {
      console.log('Sign out already in progress, skipping...')
      return
    }
    
    isProcessingSignOut.value = true
    
    
    try {
      // 1. 清理購物車狀態
      cartStore.emptyData()
      
      // 2. 清理用戶資訊
      userStore.clearUserInfo()
      
      // 3. 執行登出邏輯 (清理 token、重導向等)
      await authStore.signOut()
    } catch (error) {
      console.error('Error during unauthorized handling:', error)
      // 確保即使出錯也能導向 GSN 登入頁
      const config = useRuntimeConfig()
      await navigateTo(config.public.GSNurl, { external: true })
    } finally {
      // 重置標記，但延遲一點避免立即重複觸發
      setTimeout(() => {
        isProcessingSignOut.value = false
      }, 1000)
    }
  }

  /**
   * 手動登出 (用戶主動點擊登出)
   * 同樣需要協調清理所有狀態
   */
  const handleManualSignOut = async () => {
    await handleUnauthorized()
  }

  /**
   * 檢查是否為未授權錯誤
   */
  const isUnauthorizedError = (error: any): boolean => {
    return error?.status === 401 || 
           error?.statusCode === 401 || 
           error?.response?.status === 401
  }

  return {
    handleUnauthorized,
    handleManualSignOut,
    isUnauthorizedError,
    isProcessingSignOut: readonly(isProcessingSignOut)
  }
}